import { render, staticRenderFns } from "./gymRatingGraphicAvgStudentClean.vue?vue&type=template&id=3875c9cc&"
import script from "./gymRatingGraphicAvgStudentClean.js?vue&type=script&lang=js&"
export * from "./gymRatingGraphicAvgStudentClean.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports